import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
//components
import ModalCustom from './ModalCustom';
import FooterModal from './FooterModal';

const DeleteModalCustom = ({ name, openModal, setOpenModal, handleDelete, deleteTitle, beforeTitle}) => {
  const { t } = useTranslation(['backoffice']);
  const { setTitle} = useOutletContext()

  const handleClose = () => {
    setOpenModal(false);
    setTitle(beforeTitle)
  };

  const handleFinishDeleting = () => {
    handleDelete();
    handleClose();
  };
  useEffect(() => {
    if(openModal){
      setTitle(deleteTitle);
    }else{
      setTitle(beforeTitle)
    }
  }, [openModal, deleteTitle]);

  return (
    <ModalCustom
      show={openModal}
      onHide={handleClose}
      title={deleteTitle}
      footer={<FooterModal onCancel={handleClose} onDelete={handleFinishDeleting} />}
    >
      <h5>
        {t('segurodeeliminar')}
        {name ? ': ' + name : ''}
      </h5>
    </ModalCustom>
  );
};

DeleteModalCustom.propTypes = {
  name: PropTypes.string,
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func,
  handleDelete: PropTypes.func,
  deleteTitle: PropTypes.string,
  beforeTitle: PropTypes.string
};

export default DeleteModalCustom;
